import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DriverService } from '../../../core/services/driver.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { Pagination } from '../../../core/dto/pagination';
import { PageSize } from '../../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-single-view-driver',
  templateUrl: './single-view-driver.component.html',
  styleUrls: ['./single-view-driver.component.scss'],
})
export class SingleViewDriverComponent implements OnInit {
  breadcrumbs: any[] = [];
  driverId: any;
  driverData: any;
  loading = false;
  searchText: any;
  statusFilter: any;
  dateFilter: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  bookingData: any[] = [];
  skeletonTableColumns: any[] = [
    'Booking ID',
    'Booking Type',
    'Booking Start Date and Time',
    'Booking End Date and Time',
    'Booking Status',
    'Vehicle Reg Number',
    'Agent',
    'Customer Name',
  ];
  isVisibleSupplier = false;
  supplierId: any;

  constructor(
    private route: ActivatedRoute,
    private driverService: DriverService,
    private message: NzMessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.driverId = this.route.snapshot.paramMap.get('id');
    this.getDriverDetails();
  }

  getDriverDetails(): void {
    this.loading = true;
    this.driverService
      .getOneDriverByIdWithDetails(this.driverId)
      .then((res) => {
        this.driverData = res as any;
        this.supplierId = this.driverData?.supplierId;
        this.setBreadcrumbs(res);
        this.loading = false;
      });
  }

  setBreadcrumbs(data: any): void {
    this.breadcrumbs = [
      {
        title: `Drivers `,
        route: '/admin/drivers',
        icon: 'team',
      },
      {
        title: ` ${data?.refNo} `,
        // route: `/admin/drivers/${this.driverId}`,
      },
    ];
  }

  changeStatus(): void {
    this.loading = true;
    this.driverService
      .updateDriver({ _id: this.driverId, active: !this.driverData.active })
      .subscribe((res) => {
        this.message.success(
          this.driverData.active
            ? 'Driver has been deactivated!'
            : 'Driver has been activated!',
        );
        this.getDriverDetails();
      });
  }

  removeVehicleDetails(index: number): void {
    this.loading = true;
    const vehicles = this.driverData.vehicleDetails.splice(index, 1);
    this.driverService
      .updateDriver({
        _id: this.driverData._id,
        vehicleDetails: vehicles,
      })
      .subscribe((res) => {
        this.getDriverDetails();
      });
  }

  removeAssignVehicleDetails(index: number): void {
    this.loading = true;
    let vehicles = this.driverData?.assignsVehicles.splice(index, 1);
    if (vehicles.length > 0) {
      vehicles = vehicles.map((vehi: any) => {
        vehi._id;
      });
    } else {
      vehicles = [];
    }
    this.driverService
      .updateDriver({
        _id: this.driverData?._id,
        assignsVehicles: vehicles,
      })
      .subscribe((res) => {
        this.getDriverDetails();
      });
  }

  cancel(): void {}

  getImage(imageObj: any, type: string): string {
    let imageUrl = 'assets/img/image-placeholder.png';
    if (imageObj?.attach) {
      if (imageObj?.type === type) {
        imageUrl = imageObj?.attach?.url;
      }
    }
    return imageUrl;
  }

  goto(page?: string): void {
    if (page && page === 'supplier') {
      this.isVisibleSupplier = true;
    } else {
      const navigationExtras = {
        queryParams: {
          prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
        },
      };
      this.router.navigate(
        [`/admin/drivers/add-edit/${this.driverData?._id}`],
        navigationExtras,
      );
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedBookings();
  }

  onChangeDateFilter(result: Date[]): void {
    this.getPagedBookings();
  }

  resetSearch() {
    this.searchText = null;
    this.dateFilter = null;
    this.statusFilter = null;
    this.getPagedBookings();
  }

  search() {
    this.getPagedBookings();
  }

  getPagedBookings(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
        status: this.statusFilter,
        dateFilter: this.dateFilter,
      },
      id: this.route.snapshot.paramMap.get('id'),
    });
    console.log(payload);
    this.driverService.getDriverBookings(payload).then((res: any) => {
      this.loading = false;
      this.bookingData = res.bookings;
      console.log(res.bookings);
      this.pageSize.length = res.totalItems;
    });
  }

  navigate(data: any): void {
    if (data.bookingType === 'rent') {
      this.router.navigate([`/admin/booking-rent/${data._id}`]);
    } else if (data.bookingType === 'transfer') {
      this.router.navigate([`admin/booking-transfer/${data._id}`]);
    } else {
      this.router.navigate([`admin/booking-other/${data._id}`]);
    }
  }

  nav(data: any, flag: any): void {
    if (flag === 'agent') {
    } else {
      this.router.navigate([`admin/customers/${data}`]);
    }
  }

  visibleSupplierOnchange(event: any): void {
    if (event?.name === 'isVisible') {
      this.isVisibleSupplier = false;
    }
  }
}
